import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.5 1C4.5 0.447715 4.05228 0 3.5 0C2.94772 0 2.5 0.447715 2.5 1V2H1.5C0.671573 2 0 2.67157 0 3.5V12.5C0 13.3284 0.671573 14 1.5 14H12.5C13.3284 14 14 13.3284 14 12.5V3.5C14 2.67157 13.3284 2 12.5 2H11.5001V1C11.5001 0.447715 11.0524 0 10.5001 0C9.94784 0 9.50012 0.447715 9.50012 1V2H8V1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1V2H4.5V1ZM2.875 6.5C2.875 6.15482 3.15482 5.875 3.5 5.875H10.5C10.8452 5.875 11.125 6.15482 11.125 6.5C11.125 6.84518 10.8452 7.125 10.5 7.125H3.5C3.15482 7.125 2.875 6.84518 2.875 6.5ZM3.5 9.375C3.15482 9.375 2.875 9.65482 2.875 10C2.875 10.3452 3.15482 10.625 3.5 10.625H7.5C7.84518 10.625 8.125 10.3452 8.125 10C8.125 9.65482 7.84518 9.375 7.5 9.375H3.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }